import { z } from 'zod';

export enum InternalStatus {
  RECEIVED = 'Received',
  COORDINATOR_REVIEW = 'Coordinator Review',
  COORDINATOR_APPROVED = 'Coordinator Approved',
  ANALYST_REVIEW = 'Analyst Review',
  ANALYST_APPROVED = 'Analyst Approved',
  FINAL_APPROVAL = 'Final Approval',
  PENDING_CUSTOMER_INFO = 'Pending Customer Information',
  REJECTED = 'Rejected',
}

export const internalStatusOptions = [
  InternalStatus.RECEIVED,
  InternalStatus.COORDINATOR_REVIEW,
  InternalStatus.COORDINATOR_APPROVED,
  InternalStatus.ANALYST_REVIEW,
  InternalStatus.ANALYST_APPROVED,
  InternalStatus.FINAL_APPROVAL,
  InternalStatus.PENDING_CUSTOMER_INFO,
  InternalStatus.REJECTED,
] as const;

export const InternalStatusSchema = z.enum(internalStatusOptions);

export type InternalStatusOptions = z.infer<typeof InternalStatusSchema>;
